import { UnlocksResponse, UnlocksQueryParams } from '@/types/unlocks'
import { ProjectUnlockData, ProjectUnlockDataResponse } from '@/types/project'
import { BaseService } from './api'

class UnlockService extends BaseService {
  async getUnlocks(params?: UnlocksQueryParams): Promise<UnlocksResponse> {
    try {
      // Clean params - only include non-empty values
      const cleanParams: { limit?: number; offset?: number; search?: string; sort_by?: string; sort_direction?: string } = {
        limit: params?.limit || 10,
        offset: params?.offset || 0
      }
      
      if (params?.search?.trim()) {
        cleanParams.search = params.search.trim()
      }
      
      if (params?.sort_by) {
        cleanParams.sort_by = params.sort_by
      }
      
      if (params?.sort_direction) {
        cleanParams.sort_direction = params.sort_direction
      }
      
      const response = await this.api.get<UnlocksResponse>('/projects/unlocks', { params: cleanParams })
      
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch unlocks')
      }
      
      return response.data
    } catch (error) {
      this.handleError(error)
    }
  }

  async getProjectUnlockDetails(projectId: string): Promise<ProjectUnlockData | null> {
    try {
      const response = await this.api.get<ProjectUnlockDataResponse>(`/projects/${projectId}/unlock`)
      
      if (!response.success || !response.data || !response.data.unlock) {
        throw new Error(response.error || 'Failed to fetch project unlock details')
      }
      
      return response.data.unlock
    } catch (error) {
      console.error('Error fetching project unlock details:', error)
      return null
    }
  }

  async getUnlocksStats(): Promise<{
    upcoming_unlocks_6mo: number
    upcoming_unlocks_6mo_pct_change: number
    total_value: number
    total_value_pct_change: number
    next_30d_value: number
    next_30d_value_pct_change: number
    next_30d_events: number
    next_30d_events_pct_change: number
  }> {
    try {
      const response = await this.get<{ data: {
        upcoming_unlocks_6mo: number
        upcoming_unlocks_6mo_pct_change: number
        total_value: number
        total_value_pct_change: number
        next_30d_value: number
        next_30d_value_pct_change: number
        next_30d_events: number
        next_30d_events_pct_change: number
      } }>('/projects/unlocks/stats')
      return response.data
    } catch (error) {
      console.error('Failed to fetch unlocks stats:', error)
      throw error
    }
  }
}

export const unlockService = new UnlockService() 